module.exports = __webpack_public_path__ + "img/ball_8.f6ce1d35.png";